export class BulkRestoreResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "MPAPoliciesInfo",
            "format": ""
        },
        {
            "name": "bulkRestoreGroup",
            "baseName": "bulkRestoreGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobs",
            "baseName": "jobs",
            "type": "Array<BulkRestoreResponseJobsInner>",
            "format": ""
        },
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<BulkRestoreResponseItemsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreResponse.attributeTypeMap;
    }
    constructor() {
    }
}
